module.exports = __webpack_public_path__ + "img/dlqf.8f6264c6.svg";